import React, { useEffect, useState } from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { InputField, useFormContext } from 'clayco-controls'; 
import { RAW_PHONE } from "constants/values";

const PhoneNumberValidation = ({show, associateIdentifier, originalSmsResult, sendSMSMessage, updatePhone, close}) => {
    const {t} = useTranslation();
    const { getValues } = useFormContext();
    const [readonly, setReadonly] = useState(true);
    const [sentResults, setSentResults] = useState([]);
    const [allowSmsSend, setAllowSmsSend] = useState(false);
    const [alreadySent, setAlreadySent] = useState(true);
    const [alreadySentMessage, setAlreadySentMessage] = useState('');
    const [alreadySentSuccess, setAlreadySentSuccess] = useState(false);

    const setMessaging = smsResult => {
        if (smsResult != null) {
            setAlreadySentMessage(smsResult.verificationSent ? t('MessageSentText') : t('This phone number cannot be verified'));
            setAlreadySentSuccess(smsResult.verificationSent);
        }
        else {
            setAlreadySentMessage('');
            setAlreadySentSuccess(false);
        }
    }

    useEffect(() => {
        if (originalSmsResult != null) {
            setSentResults([originalSmsResult]);
            setMessaging(originalSmsResult);
        }
    }, [originalSmsResult])

    const onPhoneChange = (phone) => {
        const rawPhone = phone.replace(RAW_PHONE, '');
        const smsResults = sentResults.filter((r) => r?.phoneNumber === rawPhone);
        const sent = smsResults != null && smsResults.length > 0;
        setAllowSmsSend(!sent);
        setAlreadySent(sent);
        setMessaging(smsResults[0]);
    }

    const send = async () => {
        const phoneNumber = getValues('workerInfo.phoneNumber');
        updatePhone(associateIdentifier, phoneNumber);
        
        const smsResult = await sendSMSMessage(associateIdentifier, phoneNumber);

        setReadonly(true);
        if (smsResult != null) {
            setSentResults(prev => [...prev, smsResult]);
        }
        setAllowSmsSend(false);
        setAlreadySent(true);
        setMessaging(smsResult);
    }

    return (
        <>
        
        <Modal show={show} size={"lg"} centered backdrop={true}>
        <Modal.Header>
           {t("Phone Number Verification")}
        </Modal.Header>
          <Modal.Body>
            
          <div>{`${t('Thanks')} ${getValues("workerInfo.firstName")} ${getValues("workerInfo.lastName")} ${t('ForSubmitting')}`}</div>

            <Row className="justify-content-center">
                <Col className="ms-3 pt-4 h-40 fst-italic fw-bolder" style={alreadySentSuccess ? {} : { color: '#DC291A' }}>
                { alreadySent
                    ?<>{alreadySentMessage}:</> 
                    :<>{' '}</>
                }
                </Col>
            </Row>

            <Row className="justify-content-center">
                <Col className="pt-2">
                    <InputField classes="fw-bold fs-6"  placeholder={' '} label={t('Phone Number*')} disabled={readonly} name={'workerInfo.phoneNumber'} type="tel" onChange={onPhoneChange}/>
                </Col>
                <Col className="align-self-end">
                    { allowSmsSend && <Button style={{ color: '#DC291A' }}  onClick={e => send()} variant="link">{t('Send SMS Message')}</Button> }
                    { readonly && <Button style={{ color: '#DC291A' }}  onClick={e => setReadonly(!readonly)} variant="link">{t('Edit Phone Number')}</Button> }
                    { !readonly && !allowSmsSend && <Button style={{ color: '#DC291A' }}  onClick={e => setReadonly(!readonly)} variant="link">{t('Cancel Edit')}</Button> }
                    
                </Col>
            </Row>

            <div className="pt-3 text-end">
                <Button onClick={close}>{t('Close')}</Button>
            </div>

          </Modal.Body>
        </Modal>

            </>
    );
}
 
export default PhoneNumberValidation
